import _ from 'lodash';
import { TagType } from '../../../enums';
import { rewriteImageUrl } from '../../../helpers';
import { TagModel } from '../../../models/Tag';

interface ProductCardProps {
  name: string;
  imagePath: string;
  imagePath2?: string;
  tags?: TagModel[];
}
export default function ProductCard(props: ProductCardProps) {
  const { name, imagePath } = props;
  const tags = props.tags?.filter(t => t.type === TagType.ProductType);
  return (
    <div className="product-img">
      <div className="product-img-wrapper">
        <div>
          <img src={rewriteImageUrl(imagePath)} alt={name}></img>
          <div className="product-tag">
            {_.map(tags, tag => {
              return <div key={tag.id}>{tag.label}</div>;
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
